import React, { Component } from 'react'
import ResponseListItem from './ResponseListItem'
import ResponseListHeader from './ResponseListHeader'
import styles from '../../styles/common/responseList.module.css'

export class ResponseList extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.props.isOpen) {
            this.props.toggleResponseList(this.props.featureId);
        }
    }

    renderItems() {
        const { isOpen, responses, selectResponse, selection, featureId } = this.props;

        if(isOpen) {
            return (
                <div className={styles.container}>
                    {responses.map(response => {
                        return response.id !== selection ? <ResponseListItem response={response} selectResponse={selectResponse} featureId={featureId}/> : null;
                    })}
                </div>
            )
        }
        return null
    }

    render() {
        const { isOpen, responses, selection, toggleResponseList, featureId } = this.props;

        return (
            <div ref={this.wrapperRef}>
                <ResponseListHeader
                    isOpen={isOpen}
                    selection={selection}
                    responses={responses}
                    toggleResponseList={toggleResponseList}
                    featureId={featureId}
                />
                {this.renderItems()}
            </div>
        );
    }
}

export default ResponseList